import React, { useContext } from "react";
import { camelCase, startCase } from "lodash";
import { useFormContext } from "react-hook-form";
import { DATUM_DISPLAY } from "common/utils/datums";
import {
  Datum,
  FirmSource,
  FIRMType,
} from "../../../../../../generated/graphql";
import { AuthContext } from "../../../../../Authorization/AuthContext";
import {
  ButtonSection,
  Container,
  ContentSection,
  FormSection,
  HeaderSection,
  InputRow,
  PrimaryButtons,
} from "../../../../../Common/__styles__/Modal";
import { Button } from "../../../../../Common/Button";
import { Checkbox, Select, Text } from "../../../../../Inputs/react-hook-form";

export type CreateFirmStageType = {
  type: FIRMType;
  name: string;
  useForRegulation: boolean;
  datum?: Datum;
  source: FirmSource;
};

export interface CreateFirmStageProps {
  onNext: () => void;
  onCancel: () => void;
}

export const CreateFirmStage = ({ onNext, onCancel }: CreateFirmStageProps) => {
  const { control, formState, register } =
    useFormContext<CreateFirmStageType>();
  const { account } = useContext(AuthContext);
  const supportedDatums = account?.datums ?? [];

  return (
    <Container width="narrow">
      <HeaderSection>
        <h1>Create FIRM</h1>
      </HeaderSection>
      <FormSection>
        <ContentSection>
          <InputRow>
            <Text
              label="Name"
              size="medium"
              required
              {...register("name", {
                required: "Name is required",
              })}
              error={formState.errors.name?.message}
            />
          </InputRow>
          <InputRow>
            <Select
              label="FIRM type"
              name="type"
              placeholder="Select..."
              size="medium"
              control={control}
              rules={{
                required: "Type is required",
              }}
              required
              options={Object.values(FIRMType).map(type => ({
                label: startCase(camelCase(type)),
                value: type,
              }))}
              error={formState.errors.type?.message}
            />
          </InputRow>
          <InputRow>
            <Select
              label="Source"
              name="source"
              placeholder="Select..."
              size="medium"
              control={control}
              rules={{
                required: "Source is required",
              }}
              required
              options={Object.values(FirmSource).map(type => ({
                label: type,
                value: type,
              }))}
              error={formState.errors.source?.message}
            />
          </InputRow>
          <InputRow>
            <Select
              label="Datum"
              name="datum"
              placeholder="Select..."
              size="medium"
              control={control}
              options={supportedDatums?.map(datum => ({
                label: DATUM_DISPLAY[datum].short,
                value: datum,
              }))}
            />
          </InputRow>
          <InputRow>
            <Checkbox
              name="useForRegulation"
              control={control}
              label="Use for regulation"
            />
          </InputRow>
        </ContentSection>
        <ButtonSection>
          <PrimaryButtons>
            <Button styleVariant="secondary" size="medium" onClick={onCancel}>
              Cancel
            </Button>
            <Button
              type="button"
              styleVariant="primary"
              disabled={!formState.isValid}
              size="medium"
              onClick={onNext}
            >
              Next
            </Button>
          </PrimaryButtons>
        </ButtonSection>
      </FormSection>
    </Container>
  );
};

export default CreateFirmStage;
